<div class="datatable-page-header">
  <h1 trans>
    <span trans>Tags</span>
  </h1>

  <div class="header">
    <datatable-filters pluralName="tags" [filters]="filters"></datatable-filters>
    <div class="action-buttons">
      <button
        *ngIf="currentUser.hasPermission('tags.create')"
        mat-raised-button
        color="accent"
        class="button-with-icon"
        (click)="showCrupdateTagModal()"
      >
        <mat-icon svgIcon="add"></mat-icon>
        <span trans>Add New Tag</span>
      </button>
    </div>
  </div>
</div>

<div class="datatable responsive-table">
  <mat-progress-bar
    class="loading-bar"
    mode="indeterminate"
    color="accent"
    *ngIf="datatable.paginator && datatable.paginator.loading$ | async"
  ></mat-progress-bar>
  <table class="material-table">
    <thead>
      <tr>
        <th table-header-checkbox></th>
        <th table-sort-header trans>Name</th>
        <th table-sort-header trans>Type</th>
        <th table-sort-header trans>Display Name</th>
        <th table-sort-header="updated_at" trans>Last Updated</th>
        <th></th>
      </tr>
      <tr *ngIf="datatable.selectedRows$.value.length as selectedCount">
        <th colspan="6">
          <div
            class="bulk-actions-title"
            [transValues]="{count: selectedCount, resource: 'tag(s)'}"
            trans
          >
            :count :resource selected:
          </div>
          <div class="bulk-actions">
            <button
              type="button"
              mat-raised-button
              color="warn"
              (click)="maybeDeleteSelectedTags()"
              [disabled]="!currentUser.hasPermission('tags.delete')"
              trans
            >
              Delete
            </button>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let tag of tags$ | async">
        <td [table-body-checkbox]="tag.id"></td>
        <td data-label="Name">{{ tag.name }}</td>
        <td data-label="Type">{{ tag.type }}</td>
        <td data-label="Display Name">{{ tag.display_name }}</td>
        <td data-label="Last Updated">
          {{ tag.updated_at ? (tag.updated_at | formattedDate) : '-' }}
        </td>
        <td class="edit-column">
          <button
            mat-icon-button
            (click)="showCrupdateTagModal(tag)"
            *ngIf="currentUser.hasPermission('tags.update')"
            [matTooltip]="'Edit tag' | trans"
          >
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <no-results-message svgImage="folder.svg" *ngIf="datatable.paginator.noResults$ | async">
    <span primary-text trans>No tags have been created yet</span>
  </no-results-message>
  <datatable-footer></datatable-footer>
</div>
